import GoalAchievabilityIcon from "./GoalAchievabilityIcon"
export default GoalAchievabilityIcon
